import { render, staticRenderFns } from "./TemplatesEditWidget.vue?vue&type=template&id=5ff9590c&"
import script from "./TemplatesEditWidget.vue?vue&type=script&lang=js&"
export * from "./TemplatesEditWidget.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesEditWidget.vue?vue&type=style&index=0&id=5ff9590c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports